import PaymentProcessorsEnum from '~/enums/PaymentProcessorsEnum'
import type { BackendSelectedMethod } from '~/types/payment/paymentBackendTypes'
import type { FrontendPaymentProcessor } from '~/types/payment/paymentFrontedTypes'
import getPaymentProcessors from '~/utils/balance/getPaymentProcessors'

export default async (countries: any[], amount: number, country_id: number) => {
  const processors = await getPaymentProcessors(countries, amount, country_id)

  const formatted: FrontendPaymentProcessor[] = []

  processors.forEach((processor) => {
    const base: FrontendPaymentProcessor = {
      id: processor.id,
      type: processor.payment_processor_id,
      public_key: processor.payment_processor_id === PaymentProcessorsEnum.Stripe ? processor.public_key : null,
      key: null,
      fee: processor.fee,
      fee_type: processor.fee_type,
      sum_to_pay: processor.amount,
    }

    formatted.push(JSON.parse(JSON.stringify(base)))

    processor.selected_methods
      .filter((method: BackendSelectedMethod) => !method.is_leasing)
      .forEach((method: BackendSelectedMethod) => {
        formatted.push(generateSelectedPaymentMethod(base, method))
      })
  })

  return formatted
}

function generateSelectedPaymentMethod(baseMethod: FrontendPaymentProcessor, selectedMethod: BackendSelectedMethod) {
  baseMethod.key = selectedMethod.key
  baseMethod.custom_logo = selectedMethod.custom_logo

  return JSON.parse(JSON.stringify(baseMethod))
}
